import React from "react";

const menu = [
  { title: "關於向陽", path: "/about" },

  { title: "最新消息", path: "/news" },
  { title: "向陽產品", path: "/product" },
  { title: "線上購物", path: "/purchase" },
  { title: "合作提案", path: "/work" },
  { title: "營業據點", path: "/map" },
  { title: "聯絡我們", path: "/contact" }
];

const AppBar = () => {
  return (
    <div className="menu">
      <div
        className="container d-flex align-items-center"
        style={{ height: 50 }}
      >
        <a href="/" className="mr-3">
          <img src={require("../assets/logo1.png")} alt="0" height={30} />
        </a>

        {menu.map(element => (
          <a key={element.path} href={element.path} className="mx-2 text-white">
            {element.title}
          </a>
        ))}

        <div className="flex-fill" />

        <div style={{}}>
          <a href="/login" className="text-white">
            <i className="fa fa-facebook" />
          </a>
        </div>
      </div>
    </div>
  );
};

export { AppBar };
